import i18n from 'i18next';

export const homeFXList = [
  { cd: 'HKD', nm: '港元' },
  { cd: 'USD', nm: '美元' },
  { cd: 'CNH', nm: '人民幣' }
];

export const countryList = [
  { cd: 'ALL', nm: '全部' },
  { cd: 'HKG', nm: '香港' },
  { cd: 'USA', nm: '美國' },
  { cd: 'CHN', nm: '中國' },
  { cd: 'GBR', nm: '英國' },
  { cd: 'JPN', nm: '日本' },
  { cd: 'AUS', nm: '澳洲' },
  { cd: 'NZL', nm: '紐西蘭' },
  { cd: 'CAN', nm: '加拿大' },
  { cd: 'EUZ', nm: '歐元區' },
  { cd: 'FRA', nm: '歐元區' },
  { cd: 'DEU', nm: '歐元區' },
  { cd: 'EUR', nm: '歐元區' },
  { cd: 'CHE', nm: '瑞士' },
  { cd: 'DNK', nm: '丹麥' },
  { cd: 'NOR', nm: '挪威' },
  { cd: 'SWE', nm: '瑞典' },
  { cd: 'SGP', nm: '新加坡' },
  { cd: 'THA', nm: '泰國' },
  { cd: 'BRN', nm: '文萊' },
  { cd: 'ZAF', nm: '南非' }
];

export const regionList = [
  { cd: 'ALL', nm: '全部' },
  { cd: 'HKD', nm: '港元' },
  { cd: 'USD', nm: '美元' },
  { cd: 'CNH', nm: '人民幣' },
  { cd: 'GBP', nm: '英鎊' },
  { cd: 'JPY', nm: '日元' },
  { cd: 'AUD', nm: '澳元' },
  { cd: 'NZD', nm: '紐元' },
  { cd: 'CAD', nm: '加元' },
  { cd: 'EUR', nm: '歐元' },
  { cd: 'CHF', nm: '瑞士法郎' },
  { cd: 'DKK', nm: '丹麥克郎' },
  { cd: 'NOK', nm: '挪威克郎' },
  { cd: 'SEK', nm: '瑞典克郎' },
  { cd: 'SGD', nm: '新加坡元' },
  { cd: 'THB', nm: '泰國銖' },
  { cd: 'BND', nm: '文萊元' },
  { cd: 'ZAR', nm: '南非蘭特' }
];

export const ccyList = [
  { cd: 'HKD', nm: '港元' },
  { cd: 'USD', nm: '美元' },
  { cd: 'CNH', nm: '人民幣' },
  { cd: 'GBP', nm: '英鎊' },
  { cd: 'JPY', nm: '日元' },
  { cd: 'AUD', nm: '澳元' },
  { cd: 'NZD', nm: '紐元' },
  { cd: 'CAD', nm: '加元' },
  { cd: 'EUR', nm: '歐元' },
  { cd: 'CHF', nm: '瑞士法郎' },
  { cd: 'DKK', nm: '丹麥克郎' },
  { cd: 'NOK', nm: '挪威克郎' },
  { cd: 'SEK', nm: '瑞典克郎' },
  { cd: 'SGD', nm: '新加坡元' },
  { cd: 'THB', nm: '泰國銖' },
  { cd: 'BND', nm: '文萊元' },
  { cd: 'ZAR', nm: '南非蘭特' }
]

export const region2CountryList = [
  { c: 'ALL', r: 'ALL' },
  { c: 'HKG', r: 'HKD' },
  { c: 'USA', r: 'USD' },
  { c: 'CHN', r: 'CNH' },
  { c: 'GBR', r: 'GBP' },
  { c: 'JPN', r: 'JPY' },
  { c: 'AUS', r: 'AUD' },
  { c: 'NZL', r: 'NZD' },
  { c: 'CAN', r: 'CAD' },
  { c: 'CHE', r: 'CHF' },
  { c: 'DNK', r: 'DKK' },
  { c: 'NOR', r: 'NOK' },
  { c: 'SWE', r: 'SEK' },
  { c: 'SGP', r: 'SGD' },
  { c: 'THA', r: 'THB' },
  { c: 'BRN', r: 'BND' },
  { c: 'ZAF', r: 'ZAR' },
  { c: 'EUZ', r: 'EUR' }
] 

export const fxList = [
  { cd: 'USDHKD', nm_en: 'USD/HKD', nm_ch: '美元/港元', nm: '美元/港元' },
  { cd: 'CNHHKD', nm_en: 'CNH/HKD', nm_ch: '人民幣/港元', nm: '人民幣/港元' },
  { cd: 'GBPHKD', nm_en: 'GBP/HKD', nm_ch: '英鎊/港元', nm: '英鎊/港元' },
  { cd: 'JPYHKD', nm_en: 'JPY/HKD', nm_ch: '日元/港元', nm: '日元/港元' },
  { cd: 'AUDHKD', nm_en: 'AUD/HKD', nm_ch: '澳元/港元', nm: '澳元/港元' },
  { cd: 'NZDHKD', nm_en: 'NZD/HKD', nm_ch: '紐元/港元', nm: '紐元/港元' },
  { cd: 'CADHKD', nm_en: 'CAD/HKD', nm_ch: '加元/港元', nm: '加元/港元' },
  { cd: 'EURHKD', nm_en: 'EUR/HKD', nm_ch: '歐元/港元', nm: '歐元/港元' },
  { cd: 'CHFHKD', nm_en: 'CHF/HKD', nm_ch: '瑞士法郎/港元', nm: '瑞士法郎/港元' },
  { cd: 'DKKHKD', nm_en: 'DKK/HKD', nm_ch: '丹麥克郎/港元', nm: '丹麥克郎/港元' },
  { cd: 'NOKHKD', nm_en: 'NOK/HKD', nm_ch: '挪威克郎/港元', nm: '挪威克郎/港元' },
  { cd: 'SEKHKD', nm_en: 'SEK/HKD', nm_ch: '瑞典克郎/港元', nm: '瑞典克郎/港元' },
  { cd: 'SGDHKD', nm_en: 'SGD/HKD', nm_ch: '新加坡元/港元', nm: '新加坡元/港元' },
  { cd: 'THBHKD', nm_en: 'THB/HKD', nm_ch: '泰國銖/港元', nm: '泰國銖/港元' },
  { cd: 'BNDHKD', nm_en: 'BND/HKD', nm_ch: '文萊元/港元', nm: '文萊元/港元' },
  { cd: 'ZARHKD', nm_en: 'ZAR/HKD', nm_ch: '南非蘭特/港元', nm: '南非蘭特/港元' },
  { cd: 'USDCNH', nm_en: 'USD/CNH', nm_ch: '美元/人民幣', nm: '美元/人民幣' },
  { cd: 'GBPUSD', nm_en: 'GBP/USD', nm_ch: '英鎊/美元', nm: '英鎊/美元' },
  { cd: 'USDJPY', nm_en: 'USD/JPY', nm_ch: '美元/日元', nm: '美元/日元' },
  { cd: 'AUDUSD', nm_en: 'AUD/USD', nm_ch: '澳元/美元', nm: '澳元/美元' },
  { cd: 'NZDUSD', nm_en: 'NZD/USD', nm_ch: '紐元/美元', nm: '紐元/美元' },
  { cd: 'USDCAD', nm_en: 'USD/CAD', nm_ch: '美元/加元', nm: '美元/加元' },
  { cd: 'EURUSD', nm_en: 'EUR/USD', nm_ch: '歐元/美元', nm: '歐元/美元' },
  { cd: 'USDCHF', nm_en: 'USD/CHF', nm_ch: '美元/瑞士法郎', nm: '美元/瑞士法郎' },
  { cd: 'USDDKK', nm_en: 'USD/DKK', nm_ch: '美元/丹麥克郎', nm: '美元/丹麥克郎' },
  { cd: 'USDNOK', nm_en: 'USD/NOK', nm_ch: '美元/挪威克郎', nm: '美元/挪威克郎' },
  { cd: 'USDSEK', nm_en: 'USD/SEK', nm_ch: '美元/瑞典克郎', nm: '美元/瑞典克郎' },
  { cd: 'USDSGD', nm_en: 'USD/SGD', nm_ch: '美元/新加坡元', nm: '美元/新加坡元' },
  { cd: 'USDTHB', nm_en: 'USD/THB', nm_ch: '美元/泰國銖', nm: '美元/泰國銖' },
  { cd: 'USDBND', nm_en: 'USD/BND', nm_ch: '美元/文萊元', nm: '美元/文萊元' },
  { cd: 'USDZAR', nm_en: 'USD/ZAR', nm_ch: '美元/南非蘭特', nm: '美元/南非蘭特' },
  { cd: 'GBPCNH', nm_en: 'GBP/CNH', nm_ch: '英鎊/人民幣', nm: '英鎊/人民幣' },
  { cd: 'CNHJPY', nm_en: 'CNH/JPY', nm_ch: '人民幣/日元', nm: '人民幣/日元' },
  { cd: 'AUDCNH', nm_en: 'AUD/CNH', nm_ch: '澳元/人民幣', nm: '澳元/人民幣' },
  { cd: 'NZDCNH', nm_en: 'NZD/CNH', nm_ch: '紐元/人民幣', nm: '紐元/人民幣' },
  { cd: 'CNHCAD', nm_en: 'CNH/CAD', nm_ch: '人民幣/加元', nm: '人民幣/加元' },
  { cd: 'EURCNH', nm_en: 'EUR/CNH', nm_ch: '歐元/人民幣', nm: '歐元/人民幣' },
  { cd: 'CNHCHF', nm_en: 'CNH/CHF', nm_ch: '人民幣/瑞士法郎', nm: '人民幣/瑞士法郎' },
  { cd: 'CNHDKK', nm_en: 'CNH/DKK', nm_ch: '人民幣/丹麥克郎', nm: '人民幣/丹麥克郎' },
  { cd: 'CNHNOK', nm_en: 'CNH/NOK', nm_ch: '人民幣/挪威克郎', nm: '人民幣/挪威克郎' },
  { cd: 'CNHSEK', nm_en: 'CNH/SEK', nm_ch: '人民幣/瑞典克郎', nm: '人民幣/瑞典克郎' },
  { cd: 'CNHSGD', nm_en: 'CNH/SGD', nm_ch: '人民幣/新加坡元', nm: '人民幣/新加坡元' },
  { cd: 'CNHTHB', nm_en: 'CNH/THB', nm_ch: '人民幣/泰國銖', nm: '人民幣/泰國銖' },
  { cd: 'CNHBND', nm_en: 'CNH/BND', nm_ch: '人民幣/文萊元', nm: '人民幣/文萊元' },
  { cd: 'CNHZAR', nm_en: 'CNH/ZAR', nm_ch: '人民幣/南非蘭特', nm: '人民幣/南非蘭特' },
  { cd: 'GBPJPY', nm_en: 'GBP/JPY', nm_ch: '英鎊/日元', nm: '英鎊/日元' },
  { cd: 'GBPAUD', nm_en: 'GBP/AUD', nm_ch: '英鎊/澳元', nm: '英鎊/澳元' },
  { cd: 'GBPNZD', nm_en: 'GBP/NZD', nm_ch: '英鎊/紐元', nm: '英鎊/紐元' },
  { cd: 'GBPCAD', nm_en: 'GBP/CAD', nm_ch: '英鎊/加元', nm: '英鎊/加元' },
  { cd: 'EURGBP', nm_en: 'EUR/GBP', nm_ch: '歐元/英鎊', nm: '歐元/英鎊' },
  { cd: 'GBPCHF', nm_en: 'GBP/CHF', nm_ch: '英鎊/瑞士法郎', nm: '英鎊/瑞士法郎' },
  { cd: 'GBPDKK', nm_en: 'GBP/DKK', nm_ch: '英鎊/丹麥克郎', nm: '英鎊/丹麥克郎' },
  { cd: 'GBPNOK', nm_en: 'GBP/NOK', nm_ch: '英鎊/挪威克郎', nm: '英鎊/挪威克郎' },
  { cd: 'GBPSEK', nm_en: 'GBP/SEK', nm_ch: '英鎊/瑞典克郎', nm: '英鎊/瑞典克郎' },
  { cd: 'GBPSGD', nm_en: 'GBP/SGD', nm_ch: '英鎊/新加坡元', nm: '英鎊/新加坡元' },
  { cd: 'GBPTHB', nm_en: 'GBP/THB', nm_ch: '英鎊/泰國銖', nm: '英鎊/泰國銖' },
  { cd: 'GBPBND', nm_en: 'GBP/BND', nm_ch: '英鎊/文萊元', nm: '英鎊/文萊元' },
  { cd: 'GBPZAR', nm_en: 'GBP/ZAR', nm_ch: '英鎊/南非蘭特', nm: '英鎊/南非蘭特' },
  { cd: 'AUDJPY', nm_en: 'AUD/JPY', nm_ch: '澳元/日元', nm: '澳元/日元' },
  { cd: 'NZDJPY', nm_en: 'NZD/JPY', nm_ch: '紐元/日元', nm: '紐元/日元' },
  { cd: 'CADJPY', nm_en: 'CAD/JPY', nm_ch: '加元/日元', nm: '加元/日元' },
  { cd: 'EURJPY', nm_en: 'EUR/JPY', nm_ch: '歐元/日元', nm: '歐元/日元' },
  { cd: 'CHFJPY', nm_en: 'CHF/JPY', nm_ch: '瑞士法郎/日元', nm: '瑞士法郎/日元' },
  { cd: 'JPYDKK', nm_en: 'JPY/DKK', nm_ch: '日元/丹麥克郎', nm: '日元/丹麥克郎' },
  { cd: 'JPYNOK', nm_en: 'JPY/NOK', nm_ch: '日元/挪威克郎', nm: '日元/挪威克郎' },
  { cd: 'JPYSEK', nm_en: 'JPY/SEK', nm_ch: '日元/瑞典克郎', nm: '日元/瑞典克郎' },
  { cd: 'JPYSGD', nm_en: 'JPY/SGD', nm_ch: '日元/新加坡元', nm: '日元/新加坡元' },
  { cd: 'JPYTHB', nm_en: 'JPY/THB', nm_ch: '日元/泰國銖', nm: '日元/泰國銖' },
  { cd: 'JPYBND', nm_en: 'JPY/BND', nm_ch: '日元/文萊元', nm: '日元/文萊元' },
  { cd: 'JPYZAR', nm_en: 'JPY/ZAR', nm_ch: '日元/南非蘭特', nm: '日元/南非蘭特' },
  { cd: 'AUDNZD', nm_en: 'AUD/NZD', nm_ch: '澳元/紐元', nm: '澳元/紐元' },
  { cd: 'AUDCAD', nm_en: 'AUD/CAD', nm_ch: '澳元/加元', nm: '澳元/加元' },
  { cd: 'EURAUD', nm_en: 'EUR/AUD', nm_ch: '歐元/澳元', nm: '歐元/澳元' },
  { cd: 'AUDCHF', nm_en: 'AUD/CHF', nm_ch: '澳元/瑞士法郎', nm: '澳元/瑞士法郎' },
  { cd: 'AUDDKK', nm_en: 'AUD/DKK', nm_ch: '澳元/丹麥克郎', nm: '澳元/丹麥克郎' },
  { cd: 'AUDNOK', nm_en: 'AUD/NOK', nm_ch: '澳元/挪威克郎', nm: '澳元/挪威克郎' },
  { cd: 'AUDSEK', nm_en: 'AUD/SEK', nm_ch: '澳元/瑞典克郎', nm: '澳元/瑞典克郎' },
  { cd: 'AUDSGD', nm_en: 'AUD/SGD', nm_ch: '澳元/新加坡元', nm: '澳元/新加坡元' },
  { cd: 'AUDTHB', nm_en: 'AUD/THB', nm_ch: '澳元/泰國銖', nm: '澳元/泰國銖' },
  { cd: 'AUDBND', nm_en: 'AUD/BND', nm_ch: '澳元/文萊元', nm: '澳元/文萊元' },
  { cd: 'AUDZAR', nm_en: 'AUD/ZAR', nm_ch: '澳元/南非蘭特', nm: '澳元/南非蘭特' },
  { cd: 'NZDCAD', nm_en: 'NZD/CAD', nm_ch: '紐元/加元', nm: '紐元/加元' },
  { cd: 'EURNZD', nm_en: 'EUR/NZD', nm_ch: '歐元/紐元', nm: '歐元/紐元' },
  { cd: 'NZDCHF', nm_en: 'NZD/CHF', nm_ch: '紐元/瑞士法郎', nm: '紐元/瑞士法郎' },
  { cd: 'NZDDKK', nm_en: 'NZD/DKK', nm_ch: '紐元/丹麥克郎', nm: '紐元/丹麥克郎' },
  { cd: 'NZDNOK', nm_en: 'NZD/NOK', nm_ch: '紐元/挪威克郎', nm: '紐元/挪威克郎' },
  { cd: 'NZDSEK', nm_en: 'NZD/SEK', nm_ch: '紐元/瑞典克郎', nm: '紐元/瑞典克郎' },
  { cd: 'NZDSGD', nm_en: 'NZD/SGD', nm_ch: '紐元/新加坡元', nm: '紐元/新加坡元' },
  { cd: 'NZDTHB', nm_en: 'NZD/THB', nm_ch: '紐元/泰國銖', nm: '紐元/泰國銖' },
  { cd: 'NZDBND', nm_en: 'NZD/BND', nm_ch: '紐元/文萊元', nm: '紐元/文萊元' },
  { cd: 'NZDZAR', nm_en: 'NZD/ZAR', nm_ch: '紐元/南非蘭特', nm: '紐元/南非蘭特' },
  { cd: 'EURCAD', nm_en: 'EUR/CAD', nm_ch: '歐元/加元', nm: '歐元/加元' },
  { cd: 'CHFCAD', nm_en: 'CHF/CAD', nm_ch: '瑞士法郎/加元', nm: '瑞士法郎/加元' },
  { cd: 'CADDKK', nm_en: 'CAD/DKK', nm_ch: '加元/丹麥克郎', nm: '加元/丹麥克郎' },
  { cd: 'CADNOK', nm_en: 'CAD/NOK', nm_ch: '加元/挪威克郎', nm: '加元/挪威克郎' },
  { cd: 'CADSEK', nm_en: 'CAD/SEK', nm_ch: '加元/瑞典克郎', nm: '加元/瑞典克郎' },
  { cd: 'CADSGD', nm_en: 'CAD/SGD', nm_ch: '加元/新加坡元', nm: '加元/新加坡元' },
  { cd: 'CADTHB', nm_en: 'CAD/THB', nm_ch: '加元/泰國銖', nm: '加元/泰國銖' },
  { cd: 'CADBND', nm_en: 'CAD/BND', nm_ch: '加元/文萊元', nm: '加元/文萊元' },
  { cd: 'CADZAR', nm_en: 'CAD/ZAR', nm_ch: '加元/南非蘭特', nm: '加元/南非蘭特' },
  { cd: 'EURCHF', nm_en: 'EUR/CHF', nm_ch: '歐元/瑞士法郎', nm: '歐元/瑞士法郎' },
  { cd: 'EURDKK', nm_en: 'EUR/DKK', nm_ch: '歐元/丹麥克郎', nm: '歐元/丹麥克郎' },
  { cd: 'EURNOK', nm_en: 'EUR/NOK', nm_ch: '歐元/挪威克郎', nm: '歐元/挪威克郎' },
  { cd: 'EURSEK', nm_en: 'EUR/SEK', nm_ch: '歐元/瑞典克郎', nm: '歐元/瑞典克郎' },
  { cd: 'EURSGD', nm_en: 'EUR/SGD', nm_ch: '歐元/新加坡元', nm: '歐元/新加坡元' },
  { cd: 'EURTHB', nm_en: 'EUR/THB', nm_ch: '歐元/泰國銖', nm: '歐元/泰國銖' },
  { cd: 'EURBND', nm_en: 'EUR/BND', nm_ch: '歐元/文萊元', nm: '歐元/文萊元' },
  { cd: 'EURZAR', nm_en: 'EUR/ZAR', nm_ch: '歐元/南非蘭特', nm: '歐元/南非蘭特' },
  { cd: 'CHFDKK', nm_en: 'CHF/DKK', nm_ch: '瑞士法郎/丹麥克郎', nm: '瑞士法郎/丹麥克郎' },
  { cd: 'CHFNOK', nm_en: 'CHF/NOK', nm_ch: '瑞士法郎/挪威克郎', nm: '瑞士法郎/挪威克郎' },
  { cd: 'CHFSEK', nm_en: 'CHF/SEK', nm_ch: '瑞士法郎/瑞典克郎', nm: '瑞士法郎/瑞典克郎' },
  { cd: 'CHFSGD', nm_en: 'CHF/SGD', nm_ch: '瑞士法郎/新加坡元', nm: '瑞士法郎/新加坡元' },
  { cd: 'CHFTHB', nm_en: 'CHF/THB', nm_ch: '瑞士法郎/泰國銖', nm: '瑞士法郎/泰國銖' },
  { cd: 'CHFBND', nm_en: 'CHF/BND', nm_ch: '瑞士法郎/文萊元', nm: '瑞士法郎/文萊元' },
  { cd: 'CHFZAR', nm_en: 'CHF/ZAR', nm_ch: '瑞士法郎/南非蘭特', nm: '瑞士法郎/南非蘭特' },
  { cd: 'DKKNOK', nm_en: 'DKK/NOK', nm_ch: '丹麥克郎/挪威克郎', nm: '丹麥克郎/挪威克郎' },
  { cd: 'DKKSEK', nm_en: 'DKK/SEK', nm_ch: '丹麥克郎/瑞典克郎', nm: '丹麥克郎/瑞典克郎' },
  { cd: 'DKKSGD', nm_en: 'DKK/SGD', nm_ch: '丹麥克郎/新加坡元', nm: '丹麥克郎/新加坡元' },
  { cd: 'DKKTHB', nm_en: 'DKK/THB', nm_ch: '丹麥克郎/泰國銖', nm: '丹麥克郎/泰國銖' },
  { cd: 'DKKBND', nm_en: 'DKK/BND', nm_ch: '丹麥克郎/文萊元', nm: '丹麥克郎/文萊元' },
  { cd: 'DKKZAR', nm_en: 'DKK/ZAR', nm_ch: '丹麥克郎/南非蘭特', nm: '丹麥克郎/南非蘭特' },
  { cd: 'NOKSEK', nm_en: 'NOK/SEK', nm_ch: '挪威克郎/瑞典克郎', nm: '挪威克郎/瑞典克郎' },
  { cd: 'NOKSGD', nm_en: 'NOK/SGD', nm_ch: '挪威克郎/新加坡元', nm: '挪威克郎/新加坡元' },
  { cd: 'NOKTHB', nm_en: 'NOK/THB', nm_ch: '挪威克郎/泰國銖', nm: '挪威克郎/泰國銖' },
  { cd: 'NOKBND', nm_en: 'NOK/BND', nm_ch: '挪威克郎/文萊元', nm: '挪威克郎/文萊元' },
  { cd: 'NOKZAR', nm_en: 'NOK/ZAR', nm_ch: '挪威克郎/南非蘭特', nm: '挪威克郎/南非蘭特' },
  { cd: 'SEKSGD', nm_en: 'SEK/SGD', nm_ch: '瑞典克郎/新加坡元', nm: '瑞典克郎/新加坡元' },
  { cd: 'SEKTHB', nm_en: 'SEK/THB', nm_ch: '瑞典克郎/泰國銖', nm: '瑞典克郎/泰國銖' },
  { cd: 'SEKBND', nm_en: 'SEK/BND', nm_ch: '瑞典克郎/文萊元', nm: '瑞典克郎/文萊元' },
  { cd: 'SEKZAR', nm_en: 'SEK/ZAR', nm_ch: '瑞典克郎/南非蘭特', nm: '瑞典克郎/南非蘭特' },
  { cd: 'SGDTHB', nm_en: 'SGD/THB', nm_ch: '新加坡元/泰國銖', nm: '新加坡元/泰國銖' },
  { cd: 'SGDBND', nm_en: 'SGD/BND', nm_ch: '新加坡元/文萊元', nm: '新加坡元/文萊元' },
  { cd: 'SGDZAR', nm_en: 'SGD/ZAR', nm_ch: '新加坡元/南非蘭特', nm: '新加坡元/南非蘭特' },
  { cd: 'BNDTHB', nm_en: 'BND/THB', nm_ch: '文萊元/泰國銖', nm: '文萊元/泰國銖' },
  { cd: 'BNDZAR', nm_en: 'BND/ZAR', nm_ch: '文萊元/南非蘭特', nm: '文萊元/南非蘭特' },
  { cd: 'THBZAR', nm_en: 'THB/ZAR', nm_ch: '泰國銖/南非蘭特', nm: '泰國銖/南非蘭特' }
];

let fxpollList = ['AUDCAD', 'AUDJPY', 'AUDNZD', 'AUDUSD', 'CADJPY', 'EURAUD', 'EURCAD', 'EURCHF', 'EURCZK', 'EURGBP',
  'EURHRK', 'EURHUF', 'EURJPY', 'EURNOK', 'EURNZD', 'EURPLN', 'EURRON', 'EURRSD', 'EURRUB', 'EURSEK',
  'EURUSD', 'EURZAR', 'GBPCAD', 'GBPCHF', 'GBPJPY', 'GBPUSD', 'NOKSEK', 'NZDJPY', 'NZDUSD', 'CADUSD',
  'USDCHF', 'USDCNH', 'USDCNY', 'USDHKD', 'USDJPY', 'USDNOK', 'USDSEK', 'USDSGD', 'USDTHB', 'USDZAR'];


export const MAX_WATCHLIST = 30;

export const getAvailableFXPoll = (ccy: string) => {
  let list = [];

  if (!ccy || ccy === 'ALL') {
    list = fxpollList;
  } else {
    for (let i = 0; i < fxpollList.length; i++) {
      let idx = fxpollList[i].indexOf(ccy);
      if (idx === 0 || idx === 3)
        list.push(fxpollList[i]);
    }
  }
  return list;
}

export const getPairs = (ccy: string) => {
  let list = [];
  if (ccy) {
    for (let i = 0; i < fxList.length; i++) {
      if (fxList[i].cd.indexOf(ccy) > -1)
        list.push(fxList[i].cd);
    }
  }
  return list;
}

export const fx2nm = (fx: string) => {
  if (fx && fx.length === 6) {
    let ccy1 = fx.substring(0, 3);
    let ccy2 = fx.substring(3);

    return i18n.t('Common.' + ccy1, '') + '/' + i18n.t('Common.' + ccy2);
  }
}

export const fx2cd = (fx: string) => {
  if (fx && fx.length === 6) {
    let ccy1 = fx.substring(0, 3);
    let ccy2 = fx.substring(3);

    return ccy1 + '/' + ccy2;
  }
}


export const ccy2nm = (ccy: string) => {
  if (!ccy) return;
  let comp;
  if (ccy.length === 3)
    comp = ccyList;
  else
    comp = fxList;

  for (let i = 0; i < comp.length; i++) {
    if (comp[i].cd === ccy)
      return comp[i].nm;
  }
}

export const ccy2code = (ccy: string) => {
  for (let i = 0; i < fxList.length; i++) {
    if (fxList[i].cd === ccy)
      return fxList[i].nm_en;
  }
}

export const getTargetCcy = (ccypairs: string) => {
  if (ccypairs) return ccypairs.substring(0, 3);
  else return '';
}


export const getNewsCcy = (ccypairs: string, base: string) => {
  if (ccypairs && base) {
    let ccy1 = ccypairs.substring(0, 3);
    let ccy2 = ccypairs.substring(4);

    if (ccy1 === 'HKD' || ccy2 === 'HKD') {
      if (ccy1 === 'HKD') return ccy2;
      else return ccy1;
    } else {
      if (ccy1 === base) return ccy2;
      else return ccy1;
    }
  }
}

export const cc2nm = (cc: string) => {
  if (cc) {
    for (let i = 0; i < countryList.length; i++) {
      if (countryList[i].cd === cc) return countryList[i].nm;
    }
  }
}